<template>
    <div id="priceListContainer">
        <div v-if="loading" id="loading">
            <font-awesome-icon v-if="loading" id="loading-spinner" icon="spinner" spin />
        </div>
        <div v-else-if="savedPrices.length === 0" id="no-result">
            <span>Es wurden noch keine Peise gespeichert.</span>
        </div>
        <div
            v-for="savedPrice in savedPrices"
            v-else
            :key="savedPrice.save_id"
            class="savedPrice"
            :class="{ selected: selectedPrice.save_id === savedPrice.save_id }"
            @click="selectedPrice = savedPrice"
        >
            <div class="savedPrice-info">
                <span class="savedPrice-name">{{ `${savedPrice.name}` }}</span>
                <HumanReadableTime
                    class="savedPrice-timestamp"
                    :time="new Date(savedPrice.timestamp)"
                />
            </div>
            <slot v-if="selectedPrice.save_id === savedPrice.save_id" style="flex: 1;"></slot>
            <AreYouSure
                class="savedPrice-delete"
                confirm-msg="Preis löschen"
                @confirm="deletePrice(savedPrice)"
            >
                <font-awesome-icon icon="times" />
            </AreYouSure>
        </div>
    </div>
</template>

<script>
import HumanReadableTime from "@/components/widgets/HumanReadableTime";
import AreYouSure from "@/views/shared/widgets/AreYouSure";
export default {
    name: "PriceList",
    components: { AreYouSure, HumanReadableTime },
    props: {
        value: {
            type: Object,
            default: () => {}
        },
        savedPrices: {
            type: Array,
            default: () => null
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedPrice: { save_id: null }
        };
    },
    watch: {
        selectedPrice: {
            handler: function(savedPrice) {
                this.$emit("input", savedPrice);
            }
        }
    },
    methods: {
        deletePrice: function(savedPrice) {
            this.$emit("delete", savedPrice);
        }
    }
};
</script>

<style lang="scss" scoped>
#priceListContainer {
    margin: 5px 0;
    border-radius: 4px;
    overflow-x: hidden;
    border: 1px solid #ced4da;
    font-size: 0.8em;
    max-height: 150px;
    overflow-y: auto;
}
#no-result,
#loading {
    height: 145px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.savedPrice {
    cursor: pointer;
    padding: 3px 5px;
    display: flex;
    align-items: center;
}
.savedPrice:not(:last-of-type) {
    border-bottom: 1px solid #7e7e7e;
}
.savedPrice:hover {
    background: $gray-lighter;
}
.savedPrice.selected {
    background: $green;
}

.savedPrice-info {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-right: 40px;
}
.savedPrice-name {
    font-weight: bold;
}
.savedPrice-delete {
    margin: 5px;
}
</style>
